<template>
  <div class="DhCardComponent fill-height mx-2 pb-md-0 pb-2">
    <v-card class="dh-border-radius fill-height">
      <v-card-title v-if="hasSlot('title')">
        <slot name="title"/>
      </v-card-title>
      <v-card-text v-if="hasSlot('text')">
        <slot name="text"/>
      </v-card-text>
      <v-card-actions v-if="hasSlot('actions')">
        <slot name="actions"/>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'DhCard',
    components: {},
    props: {
      // https://vuejs.org/v2/guide/components.html#Prop-Validation
      // propname: String
    },
    computed: {},
    watch: {},
    mixins: [],
    data: function () {
      return {}
    },
    methods: {
      hasSlot: function (slotName) {
        return !!this.$slots[slotName] || !!this.$scopedSlots[slotName]
      }
    },
    created () {
    },
    mounted () {
    }
  }
</script>

<style scoped>
  .DhCardComponent {
    font-family: var(--dh-font-family-muli);

    .dh-border-radius {
      border-radius: 10px !important;
    }
  }
</style>
